import './styles/ManageEventAttachments.scss';
import { ManageEventAttachment_PageMap, EventCategory_CategoryTypeMap, EventItem_TypeMap } from '../../assets/keyMap';
import { AppContext, ExAppContext } from '../../Context';
import { useContext, useState, useRef, useEffect, ReactElement } from 'react';
import { IonDateString, IonDateFormat } from '../../components/IonDate';
import { useHistory } from 'react-router';
import { FilePicker } from '@capawesome/capacitor-file-picker';
import { Browser } from '@capacitor/browser';

//classes
import EventCategory from '../../exClasses/eventCategory';
import Event from '../../exClasses/event';
import EventItem from '../../exClasses/eventItem';

//mui icons
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import RemoveIcon from '@mui/icons-material/Remove';
import UploadIcon from '@mui/icons-material/Upload';
import CloseIcon from '@mui/icons-material/Close';

//controllers
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';

class AttachmentMap {
    public fileName: string = '';
    public source: string = ''; //can be base64String or urlSource
    public label: string = '';
}

const nonstate = {
    fetchDocumentsBatchSize: 10,
    max_attachment_size: 5, //5MB
    controlledImgSize: 1080
}

interface Props {

}

const ManageEventAttachments: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [page, SetPage] = useState<number>(0);
    const [filter_eventCategory, SetFilter_eventCategory] = useState<EventCategory | null>(null);
    const [filter_searchString, SetFilter_searchString] = useState<string>('');
    const [selectedEvent, SetSelectedEvent] = useState<Event | null>(null);
    const [events, SetEvents] = useState([] as Event[]);
    const [selectedEventAttachment, SetSelectedEventAttachment] = useState<EventItem | null>(null);
    // const [selectedAttachment, SetSelectedAttachment] = useState<EventItem | null>(null);
    const [attemptUploadAttachment, SetAttemptUploadAttachment] = useState<AttachmentMap | null>(null);
    const [attemptUploadAttachmentLabel, SetAttemptUploadAttachmentLabel] = useState('');
    const [newUploadAttachments, SetNewUploadAttachments] = useState<AttachmentMap[]>([] as AttachmentMap[]);
    //refs
    const pageRef = useRef<any>(null);
    const attemptUploadAttachmentRef = useRef<AttachmentMap | null>(attemptUploadAttachment);
    const newUploadAttachmentsRef = useRef<AttachmentMap[]>(newUploadAttachments);
    const uploadAttachmentCountRef = useRef<number>(-1);
    const uploadingAttachmentCountRef = useRef<number>(0);
    //router objs
    const history = useHistory();
    //controller
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    //watchers
    //test
    // useEffect(() => {
    //     console.log('ManageEventAttachmentsTest: ' + JSON.stringify(appContext.databaseActionModeQueue));
    // }, [appContext.databaseActionModeQueue]);

    //watch for filterEventCategoryUpdate, fetchEventsByEventCategory
    useEffect(() => {
        if (filter_eventCategory != null) {
            databaseInterfaceController.Queue('fetchEventsByCategory', [
                ['fetchEventsByCategory', 'true'],
                ['event_categoryID', filter_eventCategory.event_categoryID]
            ]);
        }
    }, [filter_eventCategory]);

    //watch for page change
    useEffect(() => {
        //reset 
        switch (page) {
            case ManageEventAttachment_PageMap.CATEGORY_SELECTION:
                // exAppContext.viewMode == App_ViewModeMap.MEMBER ?
                //     appContext.SetHeaderBackAction(() => () => { history.push('/Home'); })
                //     :
                //     appContext.SetHeaderBackAction(() => () => { history.push('/Profile'); }) --deprecated
                appContext.SetHeaderBackAction(() => () => { history.push('/Home'); })
                break;
            case ManageEventAttachment_PageMap.EVENT_SELECTION:
                appContext.SetHeaderBackAction(() => () => OnBackToCategorySelectionClicked());
                break;
            case ManageEventAttachment_PageMap.ATTACHMENTS:
                //fetch event gallery
                if (selectedEvent) {
                    databaseInterfaceController.Queue('fetchEventItemByEventIDAndType', [
                        ['fetchEventItemByEventIDAndType', 'true'],
                        ['eventID', selectedEvent.eventID],
                        ['type', EventItem_TypeMap.ATTACHMENT]
                    ]);
                } else {
                    SetPage(ManageEventAttachment_PageMap.EVENT_SELECTION);
                }

                //setup page back
                appContext.SetHeaderBackAction(() => () => OnBackToEventSelectionClicked());
                break;
        }
    }, [page, selectedEvent]);

    //watch for database result actions
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'fetchEventsByCategory':
                        if (!JSON.stringify(res).includes('_false')) {
                            let objArr = [] as any[];
                            try {
                                objArr = JSON.parse(res) as any[];
                            } catch {
                                objArr = res as any[];
                            }
                            const _events = [] as Event[];
                            objArr.map((obj: any) => {
                                _events.push(new Event(
                                    obj['eventID'],
                                    obj['event_categoryID'],
                                    obj['event_name'],
                                    obj['event_name_highlight_texts'],
                                    obj['event_name_highlight_colors'],
                                    obj['event_desc'],
                                    obj['event_poster'],
                                    obj['event_file'],
                                    obj['event_venue'],
                                    obj['registration_start_date'],
                                    obj['registration_end_date'],
                                    obj['early_bird_start_date'],
                                    obj['early_bird_end_date'],
                                    obj['event_start_date'],
                                    obj['event_end_date'],
                                    obj['event_schedules'],
                                    obj['max_pax'],
                                    obj['hostID'],
                                    obj['datetime_created'],
                                    obj['datetime_updated'],
                                    obj['inapp_registration'],
                                    obj['external_registration_link'],
                                    obj['first_gallery_img'] != undefined ? obj['first_gallery_img'] : ''
                                ));
                            });
                            SetEvents(SortEventsByDate(_events));
                        } else {
                            console.log('fetchOngoingAndPastEventsByBatchErr: ' + res);
                        }
                        break;
                    case 'fetchEventItemByEventIDAndType':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObj = {} as any;
                            try {
                                resObj = JSON.parse(res) as any;
                            } catch {
                                resObj = res as any;
                            }

                            if (Object.keys(resObj).length > 0) {
                                SetSelectedEventAttachment(new EventItem(
                                    resObj['itemID'],
                                    resObj['eventID'],
                                    resObj['base_url'],
                                    resObj['file_names'],
                                    resObj['datetime_expired'],
                                    resObj['type']
                                ));
                            } else {
                                SetSelectedEventAttachment(null);
                            }
                        } else {
                            console.log('fetchEventItemByEventIDAndTypeErr: ' + res);
                        }
                        break;
                    case 'uploadEventAttachment':
                        if (!JSON.stringify(res).includes('_false') && selectedEvent) {
                            uploadAttachmentCountRef.current -= 1;
                            if (uploadAttachmentCountRef.current > 0) {
                                const fileName = newUploadAttachmentsRef.current[newUploadAttachmentsRef.current.length - uploadAttachmentCountRef.current].label;

                                databaseInterfaceController.Queue('uploadEventAttachment', [
                                    ['uploadEventAttachment', 'true'],
                                    ['initiatorID', appContext.user.userID],
                                    ['eventID', selectedEvent.eventID],
                                    ['attachmentFileName', fileName],
                                    ['attachmentBase64', newUploadAttachmentsRef.current[newUploadAttachmentsRef.current.length - uploadAttachmentCountRef.current].source, false]
                                ]);
                                appContext.SetWaitScreenMessage('Uploading photos ' + (uploadingAttachmentCountRef.current - uploadAttachmentCountRef.current) + '/' + uploadingAttachmentCountRef.current + '\nDo not turn off the app');
                            } else {
                                appContext.SetPopupMessage('Successfully uploaded all event photos.');
                                appContext.SetWaitScreenShouldShow(false);
                                appContext.SetDatabaseShouldShowWaitScreen(true);
                                SetPage(ManageEventAttachment_PageMap.ATTACHMENTS);

                                //refetch eventItems
                                databaseInterfaceController.Queue('fetchEventItemByEventIDAndType', [
                                    ['fetchEventItemByEventIDAndType', 'true'],
                                    ['eventID', selectedEvent.eventID],
                                    ['type', EventItem_TypeMap.GALLERY]
                                ]);
                            }
                        } else {
                            appContext.SetPopupMessage('Event photos upload failed, please try again later.');
                            uploadAttachmentCountRef.current = 0;
                            appContext.SetWaitScreenShouldShow(false);
                            appContext.SetDatabaseShouldShowWaitScreen(true);
                            console.log('uploadEventPhotoErr: ' + res);
                        }
                        break;
                    case 'updateEventItemFileNames':
                        if (!JSON.stringify(res).includes('_false') && selectedEvent) {
                            appContext.SetPopupMessage('Successfully removed the selected photo.');
                            //refetch eventItems
                            databaseInterfaceController.Queue('fetchEventItemByEventIDAndType', [
                                ['fetchEventItemByEventIDAndType', 'true'],
                                ['eventID', selectedEvent.eventID],
                                ['type', EventItem_TypeMap.ATTACHMENT]
                            ]);
                        } else {
                            appContext.SetPopupMessage('Fail to remove the selected photo, please try again later.');
                            console.log('updateEventItemFileNamesErr: ' + res);
                        }
                        break;
                    case 'deleteEventItem':
                        if (!JSON.stringify(res).includes('_false') && selectedEvent) {
                            appContext.SetPopupMessage('Successfully removed all event photos.');
                            //refetch eventItems
                            databaseInterfaceController.Queue('fetchEventItemByEventIDAndType', [
                                ['fetchEventItemByEventIDAndType', 'true'],
                                ['eventID', selectedEvent.eventID],
                                ['type', EventItem_TypeMap.ATTACHMENT]
                            ]);
                        }
                        break;
                }
            };

            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchEventsByCategory':
                case 'fetchEventItemByEventIDAndType':
                case 'uploadEventAttachment':
                case 'updateEventItemFileNames':
                case 'deleteEventItem':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnEventCategorySelected = (eventCategory: EventCategory | null) => {
        SetFilter_eventCategory(eventCategory);
        SetPage(ManageEventAttachment_PageMap.EVENT_SELECTION);
    }
    const OnEventSelectionClicked = (event: Event) => {
        SetSelectedEvent(event);
        SetPage(ManageEventAttachment_PageMap.ATTACHMENTS);
    }
    const OnBackToCategorySelectionClicked = () => {
        SetFilter_eventCategory({} as EventCategory);
        SetPage(ManageEventAttachment_PageMap.CATEGORY_SELECTION);
    }
    const OnBackToEventSelectionClicked = () => {
        SetSelectedEventAttachment(null);
        SetSelectedEvent(null);
        SetPage(ManageEventAttachment_PageMap.EVENT_SELECTION);
    }
    const OnUploadEventAttachmentsClicked = async () => {
        appContext.SetAppStateChangeWatch(false);
        SetPage(ManageEventAttachment_PageMap.UPLOAD_ATTACHMENTS);

        appContext.SetAppStateChangeWatch(false);
        const fileTypes = [
            'image/png',
            'image/jpeg',
            'application/pdf',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint.presentation.macroenabled.12',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
            'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.template',
            'application/vnd.ms-powerpoint.template.macroenabled.12',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-word.document.macroenabled.12',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
            'application/vnd.ms-word.template.macroenabled.12',
            'text/csv',
            'text/plain'
        ];
        const files = await FilePicker.pickFiles({ readData: true, types: fileTypes, multiple: true })
            .then((res: any) => { return res.files })
            .catch((err: string) => { console.log('FilepickerPickFilesErr: ' + err); return []; });

        let someFilesOversized = false;
        files.map((file: any, i: number) => {
            if (file.size / (1048576) <= nonstate.max_attachment_size) {
                attemptUploadAttachmentRef.current = {
                    fileName: file.name,
                    source: 'data:' + file.mimeType + ';base64,' + file.data,
                    label: file.name
                } as AttachmentMap;
                // SetAttemptUploadAttachment(attemptUploadAttachmentRef.current);
                // const fileNameArr = file.name.split('.');
                // const prefix = fileNameArr[fileNameArr.length - 1];
                // SetAttemptUploadAttachmentLabel(file.name.replace('.' + prefix, '')); --deprecated
                newUploadAttachmentsRef.current.push(attemptUploadAttachmentRef.current);
                SetNewUploadAttachments([...newUploadAttachmentsRef.current]);
            } else {
                someFilesOversized = true;
            }
        });

        if (someFilesOversized) {
            appContext.SetPopupMessage('Some files are not selected, please make sure the file size is below (' + nonstate.max_attachment_size + 'MB)');
        }

    }
    const OnProceedUploadEventAttachmentsClicked = () => {
        if (newUploadAttachmentsRef.current.length > 0 && selectedEvent) {
            uploadingAttachmentCountRef.current = newUploadAttachmentsRef.current.length;
            uploadAttachmentCountRef.current = newUploadAttachmentsRef.current.length;

            appContext.SetDatabaseShouldShowWaitScreen(false);
            appContext.SetWaitScreenMessage('Uploading event attachments\ndo not turn off the app');
            appContext.SetWaitScreenShouldShow(true);
            setTimeout(() => {
                const fileName = newUploadAttachmentsRef.current[newUploadAttachmentsRef.current.length - uploadAttachmentCountRef.current].label;

                databaseInterfaceController.Queue('uploadEventAttachment', [
                    ['uploadEventAttachment', 'true'],
                    ['initiatorID', appContext.user.userID],
                    ['eventID', selectedEvent.eventID],
                    ['attachmentFileName', fileName],
                    ['attachmentBase64', newUploadAttachmentsRef.current[newUploadAttachmentsRef.current.length - uploadAttachmentCountRef.current].source, false]
                ]);
            }, 500);
        }
    }
    const OnDiscardUploadAttachmentsClicked = () => {
        appContext.SetPopupMessage('Are you sure to cancel attachments upload session?\nUpdate will not be saved');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            //reset attemptUploadAttachments
            newUploadAttachmentsRef.current = [];
            SetNewUploadAttachments([]);
            SetPage(ManageEventAttachment_PageMap.ATTACHMENTS);
        }, () => { }]);
    }
    const OnRemoveAttachmentClicked = (index: number) => {
        if(selectedEventAttachment) {
            appContext.SetPopupMessage('Are you sure to remove the selected attachment?');
            appContext.SetPopupButtons(['Yes', 'No']);
            appContext.SetPopupActions([() => {
                //proceed remove galleryItem file
                let updatedFileNames = (selectedEventAttachment.file_names.join(',')).split(',');
                updatedFileNames.splice(index, 1);
                const fileNameRemoved = selectedEventAttachment.file_names[index];
    
                databaseInterfaceController.Queue('updateEventItemFileNames', [
                    ['updateEventItemFileNames', 'true'],
                    ['initiatorID', appContext.user.userID],
                    ['itemID', selectedEventAttachment.itemID],
                    ['file_names', updatedFileNames.join(',')],
                    ['eventID', selectedEventAttachment.eventID],
                    ['fileNameRemoved', fileNameRemoved]
                ]);
            }, () => { }]);   
        }
    }

    //render functions
    const RenderPage = () => {
        switch (page) {
            default:
            case ManageEventAttachment_PageMap.CATEGORY_SELECTION:
                return RenderCategorySelectionPage();
            case ManageEventAttachment_PageMap.EVENT_SELECTION:
                return RenderEventSelectionPage();
            case ManageEventAttachment_PageMap.ATTACHMENTS:
                return RenderAttachmentsPage();
            case ManageEventAttachment_PageMap.UPLOAD_ATTACHMENTS:
                return RenderUploadAttachmentsPage();
        }
    }
    const RenderPageTitle = () => {
        switch (page) {
            case ManageEventAttachment_PageMap.CATEGORY_SELECTION:
                return (
                    <div className='page-title-block'>
                        <span className='title-lbl'>EVENT CATEGORY SELECTION</span>
                    </div>
                );
            case ManageEventAttachment_PageMap.EVENT_SELECTION:
                return (
                    <div className='page-title-block'>
                        <span className='title-lbl'>EVENT SELECTION</span>
                    </div>
                );
            case ManageEventAttachment_PageMap.ATTACHMENTS:
                return (
                    <div className='page-title-block'>
                        <span className='title-lbl'>MANAGE ATTACHMENTS</span>
                    </div>
                );
        }
    }
    const RenderCategorySelectionPage = () => {
        return (
            <div className='page category-selection' ref={pageRef}>
                {RenderPageTitle()}
                {
                    exAppContext.eventCategories.map((eventCategory: EventCategory, i: number) => {
                        return (
                            eventCategory.event_category_type == EventCategory_CategoryTypeMap.EVENT ?
                                <button className='selection-btn' key={'selection-btn-' + i} onClick={() => OnEventCategorySelected(eventCategory)}>{eventCategory.event_category_name}</button>
                                :
                                null
                        )
                    })
                }
            </div>
        )
    }
    const RenderEventSelectionPage = () => {
        const filteredEvents = FilterEventsBySearchString(FilterEventsByEventCategory(events));

        return (
            <div className="page event-selection" ref={pageRef}>
                {RenderPageTitle()}
                <div className='event-page-search-bar'>
                    <input className='event-page-search-in' value={filter_searchString} onChange={(e: any) => SetFilter_searchString(e.target.value)} placeholder='type to search' onFocus={() => SetFilter_searchString('')} />
                    <SearchIcon />
                </div>
                {
                    filteredEvents.length > 0 ?
                        filteredEvents.map((event: Event, i: number) => {
                            //return (
                            // <button className={'event-row'} key={'event-row-' + i} onClick={() => { SetSelectedEvent(event); SetPage(ManageEventAttachment_PageMap.GALLERY); }}>
                            //     <img className='event-row-img' src={event.event_poster} onError={(event: any) => { event.target.onError = null; event.target.style.display = 'none'; }} />
                            //     <div className={'event-title-row ' + (event.event_poster.replace(/\s/g, '').length == 0 ? 'center' : '')}>
                            //         <span className='event-row-lbl'>{event.event_start_datetime! ? IonDateString(event.event_start_datetime).split(' ')[0] : ''}</span>
                            //         <span className='event-row-title'>{event.event_name}</span>
                            //     </div>
                            // </button> ---deprecated to eventSelectionButton
                            //)
                            return RenderEventSelectionBtn(event, i)
                        })
                        :
                        <span className='no-event-found-lbl'>No events found<br />Please check again later</span>
                }
            </div>
        );
    }
    const RenderEventSelectionBtn = (event: Event, i: number) => {
        return (
            <button className='event-selection-btn' key={'event-selection-btn-' + i} onClick={() => OnEventSelectionClicked(event)}>
                {/* <span className='event-hosted-date-lbl'>{IonDateString(event.event_start_date!, IonDateFormat.LONG_DATE)}</span>
                <img className='event-poster-img' src={event.first_gallery_img} />
                <div className='event-title-block'>
                    <span className='event-title-lbl'>{event.event_name}</span>
                </div> --deprecated */}
                <span className='event-selection-btn-date-lbl'>{IonDateString(event.event_start_date!, IonDateFormat.LONG_DATE)}</span>
                <span className='event-selection-btn-title'>{event.event_name}</span>
            </button>
        )
    }
    const RenderAttachmentsPage = () => {
        return (
            <div className='page attachments'>
                {
                    selectedEventAttachment != null
                        && selectedEventAttachment.file_names.length > 0 ?
                        selectedEventAttachment.file_names.map((fileName: string, i: number) => {
                            return RenderAttachmentButton(fileName, i)
                        })
                        :
                        <span className='no-attachments-lbl'>No attachments found for this event<br />Click upload attachments to upload new attachments.</span>
                }
                <div className='attachments-option-panel'>
                    <button className='attachments-option-btn' onClick={() => OnUploadEventAttachmentsClicked()}><AddIcon /> Upload Attachments</button>
                </div>
            </div>
        )
    }
    const RenderAttachmentButton = (fileName: string, i: number) => {
        return (
            <div className='attachment-btn' key={'attachment-btn-' + i}>
                <button className='attachment-bg-ui' onClick={async () => { await Browser.open({ url: selectedEventAttachment?.base_url + fileName }) }}></button>
                <InsertDriveFileIcon />
                <span className='attachment-btn-lbl'>{fileName}</span>
                <button className='attachment-btn-remove-btn' onClick={() => OnRemoveAttachmentClicked(i)}><RemoveIcon /></button>
            </div>
        );
    }
    const RenderUploadAttachmentsPage = () => {

        const scrollContent = [] as ReactElement[];
        if (newUploadAttachments) {
            newUploadAttachments.map((attachment: AttachmentMap, i: number) => {
                scrollContent.push(
                    <div className='attachment-block' key={'attachment-block-' + i}>
                        <InsertDriveFileIcon />
                        <textarea className='attachment-block-area' value={attachment.label} onFocus={(e: any) => { e.target.select() }} onChange={(e: any) => {
                            //edit attachment fileName
                            const fileNameArr = attachment.fileName.split('.');
                            const fileNameExtension = '.' + fileNameArr[fileNameArr.length - 1];
                            const regex = RegExp(fileNameExtension, 'g');

                            newUploadAttachmentsRef.current[i].label = e.target.value.replace(regex, '') + fileNameExtension;
                            SetNewUploadAttachments([...newUploadAttachmentsRef.current]);
                        }} />
                        <button className='attachment-block-remove-btn' onClick={() => {
                            newUploadAttachmentsRef.current.splice(i, 1);
                            SetNewUploadAttachments(newUploadAttachmentsRef.current);
                        }}><RemoveIcon /></button>
                    </div>
                );
            });
        }
        return (
            <div className='page upload-page' ref={pageRef}>
                {
                    scrollContent.length > 0 ?
                        <div className='attachment-container'>
                            {scrollContent}
                        </div>
                        :
                        <span className='no-photos-lbl'>No attachments selected<br />Click 'Select Attachments'<br />to select files.</span>
                }
                <div className='upload-page-option-panel'>
                    <button className='upload-page-option-btn' onClick={() => OnUploadEventAttachmentsClicked()}><AddIcon />Select Attachments</button>
                    <button className='upload-page-option-btn' onClick={() => OnProceedUploadEventAttachmentsClicked()}><UploadIcon />Upload</button>
                </div>
                <button className='upload-page-close-btn' onClick={() => OnDiscardUploadAttachmentsClicked()}><CloseIcon /></button>
            </div>
        )
    }

    //exe functions
    const FilterEventsBySearchString = (events: Event[]) => {
        let res = [] as Event[];
        if (SetFilter_searchString.length > 0) {
            events.map((event: Event) => {
                if (
                    event.event_name.toLowerCase().includes(filter_searchString)
                    || event.event_desc.toLowerCase().includes(filter_searchString)
                ) {
                    res.push(event);
                }
            });
        } else {
            res = events;
        }
        return res;
    }
    const FilterEventsByEventCategory = (events: Event[]) => {
        let res = [] as Event[];
        if (filter_eventCategory != null) {
            events.map((event: Event) => {
                if (event.event_categoryID == filter_eventCategory.event_categoryID) {
                    res.push(event);
                }
            });
        } else {
            res = events;
        }
        return res;
    }
    const SortEventsByDate = (events: Event[]) => {
        let res = [] as Event[];
        events.map((event: Event) => {
            let isSorted = false;
            res.map((_res: Event, i: number) => {
                if(!isSorted &&
                    event.event_start_date && _res.event_start_date
                    && event.event_start_date >= _res.event_start_date) {
                    res.splice(i, 0, event);
                    isSorted = true;
                }
            });

            if(!isSorted) {
                res.push(event);
            }
        });

        return res;
    }

    return (
        <div className='ManageEventAttachments'>
            {
                RenderPage()
            }
        </div>
    )
}
export default ManageEventAttachments;